import React from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, FileText, BarChart3, GraduationCap, Wallet, User, KeyRound, Truck, LogOut, ChevronRight, Megaphone, CalendarDays } from "lucide-react";
import { useEmployeeAuth } from "../../context/EmployeeAuthContext";
import { isDriver, roleLabel } from "./empRoles";

function HubCard({ to, label, sub, icon: Icon, testid, onClick }) {
  const navigate = useNavigate();
  return (
    <button onClick={onClick || (() => navigate(to))} data-testid={testid}
      className="flex items-center gap-3 rounded-2xl border border-slate-800 bg-slate-800/40 p-3.5 text-left transition active:scale-[0.98] hover:border-amber-400/40">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-400/15 text-amber-300"><Icon size={20} /></span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-bold text-white">{label}</span>
        <span className="block truncate text-[11px] text-slate-400">{sub}</span>
      </span>
      <ChevronRight size={16} className="shrink-0 text-slate-600" />
    </button>
  );
}

export default function EmpHub() {
  const { employee, logout } = useEmployeeAuth();
  const driver = isDriver(employee?.position);

  const cards = [
    { to: "/karyawan/pengumuman", label: "Pengumuman", sub: "Info & pengumuman HRD", icon: Megaphone, testid: "hub-announcements" },
    { to: "/karyawan/jadwal", label: "Pengajuan & Day Off", sub: "Jadwal, cuti & jatah libur", icon: CalendarDays, testid: "hub-leave" },
    { to: "/karyawan/jobdesk", label: "Job Desk", sub: "Tugas & tanggung jawab", icon: Briefcase, testid: "hub-jobdesk" },
    { to: "/karyawan/sop", label: "SOP", sub: "Prosedur standar operasional", icon: FileText, testid: "hub-sop" },
    { to: "/karyawan/kpi", label: "KPI", sub: "Skor kinerja saya", icon: BarChart3, testid: "hub-kpi" },
    { to: "/karyawan/training", label: "Training", sub: "Pelatihan wajib", icon: GraduationCap, testid: "hub-training" },
    { to: "/karyawan/payroll", label: "Payroll", sub: "Pratinjau gaji (read-only)", icon: Wallet, testid: "hub-payroll" },
    { to: "/karyawan/profil", label: "Profil Karyawan", sub: "Data diri & atasan", icon: User, testid: "hub-profile" },
    { to: "/karyawan/ganti-pin", label: "Ganti PIN", sub: "Keamanan akun", icon: KeyRound, testid: "hub-change-pin" },
  ];
  if (driver) {
    cards.splice(0, 0, { to: "/karyawan/pengiriman", label: "Pengiriman", sub: "Daftar antar pesanan", icon: Truck, testid: "hub-deliveries" });
  }

  return (
    <div className="space-y-4" data-testid="emp-hub">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-amber-400">Portal HRD</p>
        <h2 className="font-heading text-xl font-bold text-white">Menu Lengkap</h2>
        <p className="text-xs text-slate-400">Ruang kerja {roleLabel(employee?.position)} · {employee?.branch_name || "—"}</p>
      </div>

      <div className="grid grid-cols-1 gap-2.5" data-testid="emp-hub-cards">
        {cards.map((c) => <HubCard key={c.testid} {...c} />)}
      </div>

      <button onClick={logout} data-testid="hub-logout"
        className="flex w-full items-center justify-center gap-2 rounded-2xl border border-red-500/30 bg-red-500/10 py-3 text-sm font-bold text-red-300 active:scale-[0.98]">
        <LogOut size={16} /> Keluar
      </button>
    </div>
  );
}
